import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { withEditorEvents } from 'wix-rich-content-editor-common/libs/EditorEventsContext';
import { RCEHelpersContext } from '../components/rce-helpers-context/index.js';
import { Poll } from './poll-component.js';
import { PollContextProvider } from '../components/poll-context/PollContext.js';
import 'prop-types';
import 'classnames';
import 'react-flip-move';
import 'react-measure';
import '../style-inject.es-746bb8ed.js';
import '../components/poll-option/index.js';
import '../defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../dataHooks.js';
import '../RemoveOption-0fb59667.js';
import '../assets/icons/RemoveIcon.js';
import '../components/poll-option/PollOptionBase.js';
import '../components/poll-option/types.js';
import '../components/poll-context/types.js';
import '../assets/icons/NonEditableIcon.js';
import '../assets/icons/CheckIcon.js';
import '../components/image-upload/ImageUpload.js';
import '../components/image-upload/types.js';
import '../assets/icons/LoaderIcon.js';
import '../assets/icons/ReplaceIcon.js';
import '../components/text-field/TextField.js';
import 'lodash';
import '../components/poll-option/PollListOption.js';
import '../components/poll-option/webview/PollListOptionWebview.js';
import '../option-webview-c29b68a5.js';
import '../components/poll-option/webview/PollGridOptionWebview.js';
import '../components/poll-header/PollHeader.js';
import '../components/voted-users/VotedUsers.js';
import '../components/voted-users/types.js';
import 'react-modal';
import '../VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import '../components/voted-users/VoterAvatar.js';
import 'wix-rich-content-ui-components';
import '../components/voted-users/FallbackAvatar.js';
import '../assets/icons/AddIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Polls = (props) => {
  const { theme, t, isMobile } = useContext(RicosContext);
  const setPoll = (poll) => {
    const { updateAttributes } = props;
    updateAttributes == null ? void 0 : updateAttributes({ poll });
  };
  const { componentData, helpers, editorEvents, selected, isViewMode = false, settings } = props;
  return /* @__PURE__ */ React.createElement(
    RCEHelpersContext.Provider,
    {
      value: __spreadValues({
        isViewMode: isViewMode ? isViewMode : settings.isWebView || typeof selected === "boolean" ? !selected : true,
        setInPluginEditingMode: () => {
        },
        layout: componentData.layout,
        design: componentData.design,
        preventVoting: !isViewMode,
        isPreview: isMobile,
        helpers,
        theme,
        t,
        isMobile
      }, settings)
    },
    /* @__PURE__ */ React.createElement(
      PollContextProvider,
      {
        editorEvents,
        settings,
        poll: componentData.poll,
        setPoll,
        t
      },
      /* @__PURE__ */ React.createElement(Poll, null)
    )
  );
};
var PollViewer = withEditorEvents(Polls);

export { PollViewer as default };
//# sourceMappingURL=poll-viewer.js.map
